import React from 'react';
import { Route } from 'src/navigation/Route';
import { SuggestionScreen } from './screens/Suggestion';

export const SUGGESTION_ROUTES = {
  itself: '/suggestion',
};

export const SuggestionNavigation = (): JSX.Element => (
  <React.Fragment>
    <Route
      exact
      path={SUGGESTION_ROUTES.itself}
      component={SuggestionScreen}
      //   isPrivateRoute={true}
    />
  </React.Fragment>
);
